import { useEffect, useRef } from 'react';
import { useQueryState, useMutation, useAppUI } from '@ywwwtseng/react-kit';
import { useTonWalletKit } from '@ywwwtseng/ton-wallet-kit';
import type { SelectUser } from '@/types';

export function useSyncTonWalletAddress() {
  const { showLoadingUI } = useAppUI();
  const isLoading = useRef(false);
  const { mutate } = useMutation('me:update', {
    onError: () => {
      void disconnect();
    }
  });
  const me = useQueryState<SelectUser>('me');
  const { address, connected, disconnect } = useTonWalletKit();

  useEffect(() => {
    if (isLoading.current) {
      return;
    }

    if (!me) {
      return;
    }

    const updates: Record<string, string | null> = {};

    if (connected) {
      if (me && address && me.ton_address !== address) {
        updates.ton_address = address;
      }
    } else if (!connected && me?.ton_address) {
      updates.ton_address = null;
    }

    if (Object.keys(updates).length === 1) {
      showLoadingUI(true);
      isLoading.current = true;
      void mutate(updates)
        .then(() => {
          isLoading.current = false;
          showLoadingUI(false);
        })
        .catch(() => {
          isLoading.current = false;
          showLoadingUI(false);
        });
    }
  }, [connected, address, me]);
}
